import { ApolloLink } from '@apollo/client/link/core';

const THRESHOLD_SECONDS = 5; // seconds

const requestRuntimeLoggerLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext();

    const startAt = context.requestStartedAt;
    const endAt = new Date();

    if (startAt && endAt) {
      const runtime = (endAt - startAt) / 1000;
      if (runtime > THRESHOLD_SECONDS) {
        const uuid = response?.request?.uuid;
        console.warn(`Request took ${runtime} seconds: ${uuid || "UUID Unknown"}`);
      }
    }

    return response;
  });
});

export default requestRuntimeLoggerLink;
